// pages/MentionsLegalesPage.jsx
// Page des mentions légales pour vocaverb.com

import React from 'react';
import { useTranslation } from 'react-i18next';
import './MentionsLegalesPage.css';

export default function MentionsLegalesPage() {
  const { t } = useTranslation();

  return (
    <div className="mentions-page">
      <div className="mentions-container">
        <header className="mentions-header">
          <h1 className="mentions-title">{t('mentions.title')}</h1>
          <p className="mentions-subtitle">{t('mentions.subtitle')}</p>
        </header>

        <section className="mentions-section">
          <h2 className="section-title">{t('mentions.sec1Titre')}</h2>
          <div className="mentions-content">
            <p>
              <strong>{t('mentions.nomEntrepriseLabel')}</strong> STAN-Conseil, Entreprise Individuelle.
            </p>
            <p>
              <strong>{t('mentions.siegeSocialLabel')}</strong> 15 Rue Winston CHURCHILL, 54000 Nancy, FRANCE
            </p>
            <p>
              <strong>{t('mentions.representantLabel')}</strong> BARTHELEMY Jean-Claude
            </p>
            <p>
              <strong>{t('mentions.emailLabel')}</strong> contact@vocaverb.com
            </p>
            <p>
              <strong>{t('mentions.siretLabel')}</strong> 488 505 298 00049
            </p>
          </div>
        </section>

        <section className="mentions-section">
          <h2 className="section-title">{t('mentions.sec2Titre')}</h2>
          <div className="mentions-content">
            <p>
              <strong>{t('mentions.hebergeurLabel')}</strong> Render
            </p>
            <p>
              <strong>{t('mentions.adresseLabel')}</strong> 548 Market St, PMB 72203, San Francisco, CA 94104-5401, États-Unis
            </p>
            <p>
              <strong>{t('mentions.siteWebLabel')}</strong>{' '}
              <a href="https://render.com" target="_blank" rel="noopener noreferrer">
                https://render.com
              </a>
            </p>
          </div>
        </section>

        <section className="mentions-section">
          <h2 className="section-title">{t('mentions.sec3Titre')}</h2>
          <div className="mentions-content">
            <p>{t('mentions.sec3P1')}</p>

            <h3>{t('mentions.propieteIntellectuelleTitre')}</h3>
            <p>{t('mentions.propieteIntellectuelleP')}</p>

            <h3>{t('mentions.responsabiliteTitre')}</h3>
            <p>{t('mentions.responsabiliteP')}</p>

            <h3>{t('mentions.liensHypertextesTitre')}</h3>
            <p>{t('mentions.liensHypertextesP')}</p>

            <h3>{t('mentions.protectionDonneesTitre')}</h3>
            <p>{t('mentions.protectionDonneesP')}</p>
          </div>
        </section>

        <section className="mentions-section">
          <h2 className="section-title">{t('mentions.sec4Titre')}</h2>
          <div className="mentions-content">
            <p>{t('mentions.sec4P1')}</p>

            <h3>{t('mentions.typesCookiesTitre')}</h3>
            <ul>
              <li>
                <strong>{t('mentions.cookieNecessairesLabel')}</strong> {t('mentions.cookieNecessairesText')}
              </li>
              <li>
                <strong>{t('mentions.cookiePerformanceLabel')}</strong> {t('mentions.cookiePerformanceText')}
              </li>
              <li>
                <strong>{t('mentions.cookieFonctionnaliteLabel')}</strong> {t('mentions.cookieFonctionnaliteText')}
              </li>
              <li>
                <strong>{t('mentions.cookiePublicitaireLabel')}</strong> {t('mentions.cookiePublicitaireText')}
              </li>
            </ul>

            <h3>{t('mentions.gestionCookiesTitre')}</h3>
            <p>{t('mentions.gestionCookiesP')}</p>
          </div>
        </section>

        <section className="mentions-section">
          <h2 className="section-title">{t('mentions.sec5Titre')}</h2>
          <div className="mentions-content">
            <p>{t('mentions.sec5P1')}</p>

            <h3>{t('mentions.prixTitre')}</h3>
            <p>{t('mentions.prixP')}</p>

            <h3>{t('mentions.paiementTitre')}</h3>
            <p>{t('mentions.paiementP')}</p>

            <h3>{t('mentions.droitRetractationTitre')}</h3>
            <p>{t('mentions.droitRetractationP')}</p>

            <h3>{t('mentions.resiliationTitre')}</h3>
            <p>{t('mentions.resiliationP')}</p>
          </div>
        </section>

        <section className="mentions-section">
          <h2 className="section-title">{t('mentions.sec6Titre')}</h2>
          <div className="mentions-content">
            <p>{t('mentions.sec6P1')}</p>
            <ul>
              <li>
                <strong>{t('mentions.emailContactLabel')}</strong> contact@vocaverb.com
              </li>
              <li>
                <strong>{t('mentions.adressePostaleLabel')}</strong> {t('mentions.adressePostaleText')}
              </li>
            </ul>

            <p>{t('mentions.sec6P2')}</p>
          </div>
        </section>

        <section className="mentions-section">
          <h2 className="section-title">{t('mentions.sec7Titre')}</h2>
          <div className="mentions-content">
            <p>
              {t('mentions.sec7P1Before')} <strong>{t('mentions.sec7Date')}</strong>.
            </p>
            <p>{t('mentions.sec7P2')}</p>
          </div>
        </section>

        <div className="mentions-footer">
          <p>
            © {new Date().getFullYear()} VocaVerb. {t('mentions.footerRights')}
          </p>
          <p>{t('mentions.footerMaj')}</p>
        </div>
      </div>
    </div>
  );
}
